import { render, staticRenderFns } from "./ItemVedett.vue?vue&type=template&id=fbbef694&scoped=true&"
import script from "./ItemVedett.vue?vue&type=script&lang=js&"
export * from "./ItemVedett.vue?vue&type=script&lang=js&"
import style0 from "./ItemVedett.vue?vue&type=style&index=0&id=fbbef694&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbef694",
  null
  
)

export default component.exports